import { formatDate, formatDateISO } from '@helpers/date';
import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import CtaLink from '@stories/Components/Buttons/CtaLink/CtaLink';
import * as React from 'react';
import S from './MagazineCard.styles';
import { linkAria } from '@helpers/utils';
const MagazineCard = (props) => {
    const srcs = getSrcs(props.image, 158, 132, 2, 158 / 223);
    const sizes = `${until(Device.Tablet)} 40vw, ${until(Device.DesktopSmall)} 20vw, ${until(Device.DesktopLarge)} 10vw, 158px`;
    return (React.createElement(S.Container, null,
        React.createElement(S.TopWrapper, null,
            React.createElement(S.ImageWrapper, null,
                React.createElement(S.Img, { src: srcs[0].split(' ')[0], srcSet: srcs.join(','), sizes: sizes, alt: props.image.altText ?? props.title, loading: 'lazy' })),
            React.createElement("div", null,
                React.createElement(S.Title, null, props.title),
                props.date && (React.createElement(S.Date, { dateTime: formatDateISO(props.date) }, formatDate(props.date, 'MMMM yyyy'))))),
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.Content, { dangerouslySetInnerHTML: {
                    __html: props.content,
                } }),
            props.cta || props.downloadUrl ? (React.createElement(S.ButtonsWrapper, null,
                props.cta && (React.createElement(CtaLink, { "aria-label": linkAria(props.cta.text ?? '', props.cta.target, props.translations && props.translations['lcci.link.newtab']), href: props.cta.url, target: props.cta.target }, props.cta.text)),
                props.downloadUrl && (React.createElement(CtaLink, { "aria-label": linkAria('Download', '_blank', props.translations && props.translations['lcci.link.newtab']), href: props.downloadUrl, target: "_blank", icon: "download" }, "Download")))) : null)));
};
export default MagazineCard;
